/**
 * Expense Type-related GraphQL queries
 */

export const GET_EXPENSE_TYPES_QUERY = `
  query GetExpenseTypes($where: expense_types_bool_exp) {
    expense_types(where: $where, order_by: { created_at: desc }) {
      id
      expense_type_name
      expense_type_description
      expense_type_status
      company_id
      created_at
      company {
        id
        name
      }
    }
  }
`;

export const GET_EXPENSE_TYPE_BY_ID_QUERY = `
  query GetExpenseTypeById($id: Int!) {
    expense_types_by_pk(id: $id) {
      id
      expense_type_name
      expense_type_description
      expense_type_status
      company_id
      created_at
    }
  }
`; 